module.exports = __webpack_public_path__ + "img/Ellipse 5.17c3c9ae.png";